export default __webpack_public_path__ + "static/media/ppe_detect_image.abff56ee.jpg";